import { useMemo } from "react";

import { PolicySuggestions } from "constants/policy";
import SpacePath from "components/SpacePath";
import TableSimpleCell from "ds/components/TableSimple/Cell";
import { TableSimpleCellProps } from "ds/components/TableSimple/types";
import { Policy } from "types/generated";

import useCellFilterAction from "../useCellFilterAction";

const PoliciesTableSpaceCell = ({ item: policy, ...cellProps }: TableSimpleCellProps<Policy>) => {
  const spaceFilterAction = useCellFilterAction({
    filterName: PolicySuggestions.Space,
    filterValue: policy.spaceDetails.id,
    spaceCell: true,
  });

  const actions = useMemo(() => [spaceFilterAction], [spaceFilterAction]);

  return (
    <TableSimpleCell {...cellProps} actions={actions}>
      <SpacePath spaceId={policy.spaceDetails.id} fallbackName={policy.spaceDetails.name} />
    </TableSimpleCell>
  );
};

export default PoliciesTableSpaceCell;
